/* AP 6.0 — zone E : pages services + blog/article. Petit JS sans dépendance, chargé en defer. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- onglets (suivi) ---------- */
  $$('[data-ap-tabs]').forEach(function (box) {
    var tabs = $$('[role=tab]', box);
    function sel(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { sel(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); sel(tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length], true); }
      });
    });
  });

  /* ---------- FAQ : filtres par thème + recherche ---------- */
  var faqRoot = $('#ap-faq');
  if (faqRoot) {
    var items = $$('[data-ap-faq]', faqRoot), groups = $$('[data-ap-g]', faqRoot), chips = $$('[data-ap-fg]', faqRoot);
    var stat = $('[data-ap-fstat]', faqRoot), empty = $('[data-ap-fempty]', faqRoot), qIn = $('[data-ap-faq-q]');
    items.forEach(function (d) { d._qe = $('.ap-q', d); d._q = d._qe.textContent; d._t = norm(d.textContent); });
    var curG = '';
    function apply(q) {
      var nq = norm(q).trim(), n = 0;
      groups.forEach(function (g) {
        var okG = !curG || g.getAttribute('data-ap-g') === curG, vis = 0;
        $$('[data-ap-faq]', g).forEach(function (d) {
          var ok = okG && (!nq || nq.split(/\s+/).every(function (w) { return d._t.indexOf(w) > -1; }));
          d.hidden = !ok; if (ok) { vis++; n++; }
          var w0 = nq.split(/\s+/)[0], i = nq && ok ? norm(d._q).indexOf(w0) : -1;
          d._qe.innerHTML = i > -1 ? esc(d._q.slice(0, i)) + '<mark>' + esc(d._q.slice(i, i + w0.length)) + '</mark>' + esc(d._q.slice(i + w0.length)) : esc(d._q);
          if (nq && ok) d.open = vis === 1 && n === 1; else if (!nq) d.open = false;
        });
        g.hidden = vis === 0;
      });
      if (stat) { stat.hidden = !nq; stat.textContent = (stat.getAttribute('data-tpl') || '').replace('%n', n).replace('%q', q.trim()); }
      if (empty) empty.hidden = n > 0;
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        curG = c.getAttribute('data-ap-fg');
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c); });
        apply(qIn ? qIn.value : '');
      });
    });
    if (qIn) {
      qIn.addEventListener('input', function () { apply(qIn.value); });
      var f = qIn.form;
      if (f) f.addEventListener('submit', function (e) { e.preventDefault(); apply(qIn.value); faqRoot.scrollIntoView({ behavior: 'smooth' }); });
      $$('[data-ap-hq]').forEach(function (b) {
        b.addEventListener('click', function () { qIn.value = b.getAttribute('data-ap-hq'); apply(qIn.value); faqRoot.scrollIntoView({ behavior: 'smooth' }); });
      });
    }
    $$('[data-ap-faq-clear]').forEach(function (b) { b.addEventListener('click', function () { if (qIn) qIn.value = ''; curG = ''; chips.forEach(function (x, i) { x.setAttribute('aria-pressed', i === 0); }); apply(''); }); });
    function openHash() {
      var id = location.hash.slice(1); if (!id) return;
      var d = document.getElementById(id); if (d && d.tagName === 'DETAILS') { d.open = true; }
    }
    $$('[data-ap-open]').forEach(function (a) { a.addEventListener('click', function () { var d = document.getElementById(a.getAttribute('data-ap-open')); if (d) { d.open = true; setTimeout(function () { d.scrollIntoView({ behavior: 'smooth' }); }, 10); } }); });
    window.addEventListener('hashchange', openHash); openHash();
  }

  /* ---------- contact : aide contextuelle selon le sujet ---------- */
  var subj = $('[data-ap-subject]'), hint = $('[data-ap-subj-hint]');
  if (subj && hint) {
    var upd = function () {
      var i = subj.options[subj.selectedIndex].getAttribute('data-i'), h = hint.getAttribute('data-h' + i);
      hint.hidden = !h; if (h) hint.innerHTML = h;
    };
    subj.addEventListener('change', upd); upd();
  }

  /* ---------- estimation en devise : taux BCE de assets/ap-fx.js (window.AP_FX), jamais de taux en dur ---------- */
  var conv = $('[data-ap-conv]');
  if (conv) {
    var start = function () {
      var fx = window.AP_FX; if (!fx || !fx.rates) return;
      var eur = $('[data-ap-conv-eur]', conv), cur = $('[data-ap-conv-cur]', conv), out = $('[data-ap-conv-out]', conv), rate = $('[data-ap-conv-rate]', conv);
      $$('option', cur).forEach(function (o) { if (!fx.rates[o.value]) o.remove(); });
      if (!cur.options.length || !eur.options.length) return;
      var byC = { US: 'USD', GB: 'GBP', CH: 'CHF', CA: 'CAD', AU: 'AUD', NZ: 'NZD' }[conv.getAttribute('data-country')];
      if (byC && fx.rates[byC]) cur.value = byC;
      var loc = document.documentElement.lang || 'fr';
      var run = function () {
        var r = fx.rates[cur.value], v = parseInt(eur.value, 10) / 100 * r;
        try { out.textContent = '≈ ' + new Intl.NumberFormat(loc, { style: 'currency', currency: cur.value }).format(v); } catch (e) { out.textContent = '≈ ' + v.toFixed(2) + ' ' + cur.value; }
        var d = fx.date ? new Date(fx.date + 'T12:00:00').toLocaleDateString(loc) : '';
        rate.textContent = (rate.getAttribute('data-tpl') || '').replace('%r', '1 € = ' + r.toLocaleString(loc, { maximumFractionDigits: 4 }) + ' ' + cur.value).replace('%d', d);
      };
      eur.addEventListener('change', run); cur.addEventListener('change', run); run();
      conv.hidden = false;
    };
    if (window.AP_FX) start(); else window.addEventListener('load', start);
  }

  /* ---------- article : sommaire (h2 du contenu), numéros, tableaux, progression ---------- */
  var prose = $('[data-ap-prose]');
  if (prose) {
    var hs = $$('h2', prose).filter(function (h) { return h.textContent.trim(); });
    // bloc « L'essentiel » : premier h2 suivi d'une liste, en tête d'article
    var first = hs[0];
    if (first && first.nextElementSibling && /^(UL|OL)$/.test(first.nextElementSibling.tagName) && $$('p', prose).indexOf(first.previousElementSibling) < 3) {
      var box = document.createElement('section'); box.className = 'ap-ar-callout';
      first.parentNode.insertBefore(box, first); box.appendChild(first); box.appendChild(box.nextElementSibling);
    }
    $$('table', prose).forEach(function (t) {
      if (t.parentNode.classList.contains('ap-ar-tbl')) return;
      var w = document.createElement('div'); w.className = 'ap-ar-tbl'; t.parentNode.insertBefore(w, t); w.appendChild(t);
      var th = $$('thead th', t).map(function (x) { return x.textContent.trim(); });
      if (th.length) $$('tbody tr', t).forEach(function (tr) { $$('td', tr).forEach(function (td, i) { if (i && th[i]) td.setAttribute('data-l', th[i]); }); });
    });
    var used = {}, n = 0, links = [];
    var tocs = $$('[data-ap-toc]'), cur = $('[data-ap-toc-cur]'), bars = $$('[data-ap-read]');
    hs.forEach(function (h) {
      var base = (h.id || norm(h.textContent).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60)) || 's';
      var id = base, k = 2; while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) id = base + '-' + k++;
      used[id] = 1; h.id = id;
      if (!h.closest('.ap-ar-callout')) { n++; var no = document.createElement('span'); no.className = 'ap-ar-no'; no.setAttribute('aria-hidden', 'true'); no.textContent = (n < 10 ? '0' : '') + n; h.insertBefore(no, h.firstChild); }
      var txt = h.lastChild && h.lastChild.nodeType === 3 ? h.lastChild.textContent : h.textContent.replace(/^\d+/, '');
      tocs.forEach(function (ol) {
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + id; a.textContent = txt.trim(); li.appendChild(a); ol.appendChild(li); links.push([a, h]);
        a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.open = false; });
      });
    });
    if (!hs.length) $$('[data-ap-toc-box]').forEach(function (b) { b.hidden = true; });
    var tick = false;
    var onScroll = function () {
      tick = false;
      var y = window.scrollY + 140, act = null;
      hs.forEach(function (h) { if (h.getBoundingClientRect().top + window.scrollY <= y) act = h; });
      links.forEach(function (l) { l[0].classList.toggle('is-on', l[1] === act); });
      if (cur) cur.textContent = act ? (act.lastChild.nodeType === 3 ? act.lastChild.textContent : act.textContent) : cur.getAttribute('data-default');
      var r = prose.getBoundingClientRect(), p = Math.min(1, Math.max(0, (window.innerHeight * .5 - r.top) / r.height));
      bars.forEach(function (b) { b.style.width = (p * 100).toFixed(1) + '%'; });
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }

  /* ---------- partage : copier le lien ---------- */
  $$('[data-ap-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var done = function () { var l = b.querySelector('[data-l]'); if (l) { var o = l.textContent; l.textContent = b.getAttribute('data-ok'); setTimeout(function () { l.textContent = o; }, 1800); } };
      if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-ap-copy')).then(done, function () {});
    });
  });
})();
